// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3VUj6","productName":"Table_productName__2RKi_"};